import { render, staticRenderFns } from "./professor-anoLectivo.vue?vue&type=template&id=15b1ded7&"
import script from "./professor-anoLectivo.vue?vue&type=script&lang=js&"
export * from "./professor-anoLectivo.vue?vue&type=script&lang=js&"
import style0 from "./professor-anoLectivo.vue?vue&type=style&index=0&id=15b1ded7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports